import { MARKET_REGIONS, MARKETS, TMarketRegion } from "./markets";

/** The region ids, as an enum-style lookup. Derived from `MARKETS`. */
export const CONTENT_REGION = Object.fromEntries(
  MARKET_REGIONS.map((region) => [region, region]),
) as { [K in TMarketRegion]: K };

const buildRegionLookups = () => {
  const byCountry: Record<string, TMarketRegion> = {};
  const byCurrency: Record<string, TMarketRegion> = {};

  for (const region of MARKET_REGIONS) {
    const market = MARKETS[region];

    for (const country of market.countries) byCountry[country] = region;

    byCurrency[market.currency] = region;
  }

  return { byCountry, byCurrency };
};

const { byCountry, byCurrency } = buildRegionLookups();

export const CONTENT_REGIONS: Record<string, TMarketRegion> = byCountry;

// Keyed by ISO code — normalise symbols through `CURRENCY_CODE_MAP` first.
export const CURRENCY_CONTENT_REGIONS: Record<string, TMarketRegion> =
  byCurrency;
